import { Link } from 'react-router-dom';
import type { CaseLinks, LinkedCase } from '../../../../types/LegalCase';
import { hasCaseLinks, linkedCaseLabel } from './caseLinks';
import { HelpButton } from './SectionHelp';

interface CaseLinksBlockProps {
    links?: CaseLinks | null;
}

const LinkedCaseLine = ({ linked }: { linked: LinkedCase }) => (
    <li className="flex flex-wrap items-baseline gap-x-2">
        <Link
            to={`/recovery/legal-cases/${linked.id}`}
            className="text-blue-600 dark:text-blue-400 hover:underline focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:text-blue-400 rounded"
        >
            {linkedCaseLabel(linked)}
        </Link>
        <span className="text-xs text-gray-500 dark:text-gray-400">
            {linked.caseTypeFormatted} · {linked.statusFormatted}
        </span>
    </li>
);

// AF-3972 extensão (R1): no detalhe, de onde o caso veio e para onde foi escalado, com link para o
// outro caso. Sem vínculo (ou payload sem `caseLinks`, front publicado antes do backend) não mostra
// nada.
const CaseLinksBlock = ({ links }: CaseLinksBlockProps) => {
    if (!hasCaseLinks(links)) return null;
    return (
        <div className="border-t border-gray-200 dark:border-slate-700 pt-3 space-y-2">
            <div className="flex items-center gap-1">
                <h4 className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                    Vínculo entre casos
                </h4>
                <HelpButton topic="case.links" label="Abrir ajuda: vínculo entre casos" />
            </div>
            {links.escalatedFrom && (
                <div className="text-sm">
                    <p className="text-gray-500 dark:text-gray-400">Veio do caso</p>
                    <ul className="dark:text-white">
                        <LinkedCaseLine linked={links.escalatedFrom} />
                    </ul>
                </div>
            )}
            {links.escalatedTo.length > 0 && (
                <div className="text-sm">
                    <p className="text-gray-500 dark:text-gray-400">Escalado para</p>
                    <ul className="space-y-1 dark:text-white">
                        {links.escalatedTo.map((linked) => <LinkedCaseLine key={linked.id} linked={linked} />)}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default CaseLinksBlock;
